import React from "react";
import { useRequestPhoneCodeMutation } from "src/generated/graphql";
import { useForm } from "react-hook-form";

interface IRequestPhoneCodeProps {
  header: string;
  setPhone: React.Dispatch<React.SetStateAction<string>>;
  setFormSequence: React.Dispatch<
    React.SetStateAction<"phoneNumber" | "phoneCode">
  >;
}
const RequestPhoneCode: React.FC<IRequestPhoneCodeProps> = ({
  header,
  setPhone,
  setFormSequence,
}) => {
  const [requestPhoneCode] = useRequestPhoneCodeMutation();

  const { handleSubmit, errors, setError, clearErrors, register } = useForm<{
    phoneNumber: string;
    phoneCode: string;
  }>({
    defaultValues: { phoneNumber: "" },
  });

  const onSubmit = handleSubmit(async (variables) => {
    const {
      data: {
        requestPhoneCode: { phoneNumber, errors },
      },
    } = await requestPhoneCode({
      variables: {
        phoneNumber: variables.phoneCode + variables.phoneNumber,
      },
    });

    if (phoneNumber) {
      setPhone(phoneNumber);
      setFormSequence("phoneCode");
    } else if (errors) {
      errors.forEach((error) => {
        setError(error.path as any, { type: "manual", message: error.detail });
      });
    }
  });

  return (
    <form onSubmit={onSubmit} className="flex flex-col items-center">
      <h1 className="text-3xl mb-10 w-full">{header}</h1>

      <div className="w-full">
        <div className="relative">
          <div className="absolute inset-y-0 left-0 flex items-center">
            <select
              name="phoneCode"
              aria-label="Phone Code"
              className="form-select h-full py-0 pr-7 border-transparent bg-transparent border-0 rounded-none focus:shadow-none"
              ref={register}
            >
              <option>+60</option>
              <option>+61</option>
            </select>
          </div>
          <input
            id="phoneNumber"
            className="form-input block w-full pl-20 border-0 border-b border-gray-200 rounded-none focus:border-gray-400 focus:shadow-none"
            placeholder="Enter phone number"
            name="phoneNumber"
            ref={register({
              required: "Required",
            })}
          />
        </div>
      </div>

      {Object.values(errors).map((error, index) => (
        <p key={index} className="text-red-500">
          {error.message}
        </p>
      ))}

      <button
        type="submit"
        className="btn btn-primary py-4 mt-8"
        onClick={() => clearErrors()}
      >
        REQUEST CODE
      </button>
    </form>
  );
};

export default RequestPhoneCode;
